import React from 'react'
import { Redirect } from 'react-router-dom'

import Dashboard from '../pages/Dashboard/index'

import Basic4 from '../pages/Basic4/index'
import Basic4Single from '../pages/Basic4/single'

import MasterMind from '../pages/MasterMind/index'
import MasterMindSingle from '../pages/MasterMind/single'

import Game24 from '../pages/Game24/index'
import Game24Single from '../pages/Game24/single'

const userRoutes = [
  { path: '/dashboard', component: Dashboard },
  { path: '/basic4', component: Basic4 },
  { path: '/basic4/single', component: Basic4Single },
  { path: '/mastermind', component: MasterMind },
  { path: '/mastermind/single', component: MasterMindSingle },
  { path: '/24-game', component: Game24 },
  { path: '/24-game/single', component: Game24Single },

  // this route should be at the end of all other routes
  { path: '/', exact: true, component: () => <Redirect to='/dashboard' /> }
]

const authRoutes = []

export { userRoutes, authRoutes }
